import {
  EquipmentGetInfoSuccess,
  EquipmentDetailsSuccess,
  InviteMemberSuccess,
  GetEquipmentFilterSuccess,
  GetPrimaryFieldSuccess,
  GetInvoiceListSuccess,
} from '../../actionTypes/equipmentInfoActions';

const inititalState = {
  equipmentInfoList: [],
  customerEquipmentDetails: {},
  inviteMemberList: [],
  equipmentFilterList: {},
  primaryField: [],
  invoiceList: [],
};

export const equipmentsInfoReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case EquipmentGetInfoSuccess:
      return {
        ...state,
        equipmentInfoList: payload,
      };
    case EquipmentDetailsSuccess:
      return {
        ...state,
        customerEquipmentDetails: payload,
      };
    case InviteMemberSuccess:
      return {
        ...state,
        inviteMemberList: payload,
      };
    case GetEquipmentFilterSuccess:
      return {
        ...state,
        equipmentFilterList: payload,
      };
    case GetInvoiceListSuccess:
      return {
        ...state,
        invoiceList: payload,
      };
    case GetPrimaryFieldSuccess:
      return {
        ...state,
        primaryField: payload,
      };

    default:
      return state;
  }
};
